import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UserService } from '@app-services/user/user.service';
import { GAnalyticsService } from '@app-services/g-analytics/g-analytics.service';
import { clearLocalStorage, navigateBetweenProjects } from 'src/app/helpers/functions';


@Component({
  selector: 'app-create-password',
  templateUrl: './create-password.component.html',
  styleUrls: ['./create-password.component.css']
})
export class CreatePasswordComponent implements OnInit {
  passwordForm!: FormGroup
  show_button1: boolean = false
  show_button2: boolean = false
  constructor(
    private fb: FormBuilder,
    private userService: UserService,
    private router: Router,
    private gaService: GAnalyticsService,
  ) { }

  ngOnInit(): void {
    this.passwordForm = this.fb.group({
      password: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', [Validators.required]]
    },
    { 
      validator: this.ConfirmedValidator('password', 'confirmPassword')
    }
    )
  }
  get pwd(){
    return this.passwordForm.controls;
  }
  resetPassword() {
    let userobj = JSON.parse(localStorage.getItem('mobile_and_name'))
    this.gaService.webEngageEvent({
      'event': 'Forgot password successful',
      'phone': userobj?.phone
    })
    console.log(userobj.userId)
    this.userService.updatePassword(this.passwordForm.value.password, userobj.userId).subscribe((data: any) => {
      if (data) {
        clearLocalStorage();
        this.router.navigateByUrl('/signin', { state: { passwordReseted: true } })
      }
    },
      (error: any) => {                                     // on error
        alert(error.error.message);
      });
  }
  

  ConfirmedValidator(controlName: string, matchingControlName: string){
    return (formGroup: FormGroup) => {
        const control = formGroup.controls[controlName];
        const matchingControl = formGroup.controls[matchingControlName];
        if (matchingControl.errors && !matchingControl.errors.confirmedValidator) {
            return;
        }
        if (control.value !== matchingControl.value) {
            matchingControl.setErrors({ confirmedValidator: true });
        } else {
            matchingControl.setErrors(null);
        }
    }
}
}


